export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14455.a5282b40.jpg";